"use client";

import { useEffect, useState } from "react";

/**
 * `value`, but only after it has stopped changing for `delayMs` — e.g. a
 * search box that should query once the person pauses typing, not per key.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
